import React from 'react'
import {Icon} from '@chakra-ui/react'

const ProductRegistrationIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M21 11.97C20.45 11.97 20 12.42 20 12.97V19.97C20 20.52 19.55 20.97 19 20.97H5C4.45 20.97 4 20.52 4 19.97V5.97C4 5.42 4.45 4.97 5 4.97H12C12.55 4.97 13 4.51999 13 3.97C13 3.42 12.55 2.97 12 2.97H5C3.35 2.97 2 4.31 2 5.97V19.97C2 21.62 3.35 22.97 5 22.97H19C20.65 22.97 22 21.62 22 19.97V12.97C22 12.42 21.55 11.97 21 11.97Z"
                fill="black"
            />
            <path
                d="M22.08 2.88C20.9 1.7 18.84 1.7 17.67 2.88L8.66 11.9C8.31 12.25 8.04 12.7 7.9 13.18L7.06 16.05C6.98 16.33 6.98 16.62 7.06 16.89C7.25 17.54 7.85 17.97 8.5 17.97C8.64 17.97 8.78 17.95 8.92 17.91L11.79 17.07C12.27 16.93 12.71 16.67 13.07 16.31L22.08 7.3C23.3 6.08 23.3 4.1 22.08 2.89V2.88ZM20.67 5.88L11.66 14.89C11.54 15.01 11.39 15.1 11.23 15.14L9.23 15.72L9.81 13.72C9.86 13.56 9.94 13.41 10.06 13.29L19.08 4.29999C19.29 4.08999 19.57 3.97 19.87 3.97C20.17 3.97 20.45 4.08999 20.66 4.29999C21.1 4.74 21.1 5.45 20.66 5.89L20.67 5.88Z"
                fill="black"
            />
        </Icon>
    )
}

export default ProductRegistrationIcon
